import { useMemo } from 'react';
import ConsultantBookings from '../services/ConsultantBookings';
import consultantBookingErrorActions from '../actions/consultantBookingErrorActions';

export default () => {
  const { logConsultantBookingError: logError } = consultantBookingErrorActions();

  return useMemo(() => ConsultantBookings.getInstance(logError), [logError]);
};
